import { Pipe, PipeTransform } from '@angular/core';
import { DeviceErrorCollection, ErrorKeys } from '../devices.models';
import sum from 'lodash-es/sum';

@Pipe({
    name: 'liebherrErrorMessages',
})
export class ErrorMessagesPipe implements PipeTransform {
    transform(errorKeys: ErrorKeys[], errors: DeviceErrorCollection) {
        const messages: { translation: string; data: any }[] = [];
        // error hints by
        const messageTranslations = {
            [ErrorKeys.routerTypeRequired]: 'DEVICES.IMPORT.ROUTER_TYPE_HINT',
            [ErrorKeys.routerTypeInvalid]: 'DEVICES.IMPORT.ROUTER_TYPE_INVALID',
            [ErrorKeys.routerTypeVendorMatch]: 'DEVICES.IMPORT.ROUTER_TYPE_VENDOR_MATCH_HINT',
            [ErrorKeys.serialNumber]: 'DEVICES.IMPORT.SERIAL_NUMBER_HINT',
            [ErrorKeys.serialNumberDuplicate]: 'DEVICES.IMPORT.DUPLICATE_HINT',
            [ErrorKeys.imei]: 'DEVICES.IMPORT.IMEI_HINT',
            [ErrorKeys.imeiDuplicate]: 'DEVICES.IMPORT.DUPLICATE_HINT',
            [ErrorKeys.iccid]: 'DEVICES.IMPORT.ICCID_HINT',
            [ErrorKeys.iccidDuplicate]: 'DEVICES.IMPORT.DUPLICATE_HINT',
            [ErrorKeys.date]: 'DEVICES.IMPORT.DATE_HINT',
            [ErrorKeys.vendor]: 'DEVICES.IMPORT.VENDOR_HINT',
            [ErrorKeys.vendorRouterTypeMatch]: 'DEVICES.IMPORT.VENDOR_ROUTER_TYPE_MATCH_HINT',
        };
        // get the combined error count for
        const errorCount = sum(errorKeys.map((key) => errors[key] || 0));

        if (errorCount > 0) {
            // always push the error count hint
            messages.push({
                translation: errorCount === 1 ? 'DEVICES.IMPORT.ERRORS_SINGULAR' : 'DEVICES.IMPORT.ERRORS_PLURAL',
                data: { count: errorCount },
            });

            // check for error and add error message for each error key
            errorKeys.forEach((key) => {
                const count = errors[key] || 0;
                if (count > 0) {
                    messages.push({
                        translation: messageTranslations[key],
                        data: [ErrorKeys.iccidDuplicate, ErrorKeys.imeiDuplicate, ErrorKeys.serialNumberDuplicate].includes(key)
                            ? { count }
                            : undefined,
                    });
                }
            });
        }
        return messages;
    }
}
